import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { TextareaInlineField } from '../../../../Textarea'
import {
  BUILDING_FORM_FIELD_NAME_NOTES,
  BUILDING_FORM_NOTES_FIELD_MAX_LENGTH,
} from '../../BuildingForm.constants'

import { BUILDING_FORM_NOTES_FIELD_MIN_ROWS } from './NotesField.constants'

function NotesField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      clearable
      hasCounter
      Component={TextareaInlineField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        info: t('Building.NotesInfoKey'),
        label: `${t('Building.NotesLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      maxLength={BUILDING_FORM_NOTES_FIELD_MAX_LENGTH}
      minRows={BUILDING_FORM_NOTES_FIELD_MIN_ROWS}
      name={BUILDING_FORM_FIELD_NAME_NOTES}
      placeholder={t('Building.NotesPlaceholderKey')}
    />
  )
}

export default NotesField
